"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authLeaderboardContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.authLeaderboardContract = c.router({
    getPointsBreakdown: {
        method: 'GET',
        path: '/points-breakdown',
        responses: {
            200: zod_1.z.object({
                breakdown: zod_1.z.array(zod_1.z.object({
                    id: zod_1.z.string(),
                    created_at: zod_1.z.coerce.date(),
                    action: models_1.ZLeaderboardAction,
                    points: zod_1.z.number(),
                })),
            }),
        },
    },
    getRankAndPointsTotal: {
        method: 'GET',
        path: '/rank-and-points-total',
        responses: {
            200: zod_1.z.object({
                rank: zod_1.z.number().nullable(),
                pointsTotal: zod_1.z.number(),
                raffleEntries: zod_1.z.number(),
            }),
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/auth',
    strictStatusCodes: true,
    baseHeaders: zod_1.z.object({
        'x-access-token': zod_1.z.string(),
    }),
    commonResponses: {
        401: c.type(),
    },
});
//# sourceMappingURL=leaderboard.auth.contract.js.map